export const initSectionVideo = () => {
	const components = Array.from(document.querySelectorAll(`section.video`));

	if ( !components.length )
	{
		return;
	}

	components.forEach( ( component ) => {

		const createFrameVideo = ( src ) => {
			const iframe = document.createElement('iframe');
			
			iframe.src = src;
			iframe.frameBorder = '0';
			iframe.allow = 'autoplay;encrypted-media;fullscreen';
			iframe.allowfullscreen = true;

			iframe.addEventListener('load', () => {
				component.classList.remove('loading');
				component.classList.add('loaded');
			});

			component.querySelector(`div.wrapper`).appendChild( iframe );
		}

		component.addEventListener(`click`, () => {

			if ( !component.classList.contains(`loading`) && !component.classList.contains(`loaded`) )
			{
				component.classList.add(`loading`);
				
				const video = component.querySelector(`video`);
				
				if ( video )
				{
					const playVideo = () => {
						component.classList.remove(`loading`);
						component.classList.add(`loaded`);
						video.play();
					};
					
					video.pause();
					video.currentTime = 0;
					
					video.readyState > 3 ? playVideo() : video.addEventListener( `canplaythrough`, playVideo);
				} else if ( !component.dataset.src.includes('vk.com') )
				{
					const iframe = document.createElement(`iframe`);
					const src = component.getAttribute(`data-src`).replace( /(.*)?v=/, ``).replace(/(.*shorts\/)/, ``).replace(/\?.+/, ``).replace(/&(.*)/,`` );

					iframe.src = `https://www.youtube.com/embed/${src}?autoplay=1&rel=0&modestbranding=1`;
					
					createFrameVideo(`https://www.youtube.com/embed/${src}?autoplay=1&rel=0&modestbranding=1`);
				} else 
				{
					let src = '';
					if ( src = component.dataset.src.includes('video_ext.php') ) {
						src = component.dataset.src.includes('autoplay') ? component.dataset.src : component.dataset.src + '&autoplay=1';
					} else {
						const videoId = component.dataset.src.split('video-')[1].split('?')[0].split('_');
						src = `https://vk.com/video_ext.php?oid=-${videoId[0]}&id=${videoId[1]}&hd=2&autoplay=1`
					}
					
					createFrameVideo(src);
				}
			}
		});
	} );
};
